var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"pageRoot"}},[_c('img',{attrs:{"id":"bg","src":"/pages/img/blindcas/svgBCas11bg.svg"}}),_c('saved-input-narrator-friendly',{attrs:{"page":_vm.$parent.page,"type":_vm.$parent.type,"number":"2","id":"inputField01"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }